import React, { useState, useRef } from "react";
import { motion } from "framer-motion";
import INPUT_TYPES from "../constants/input-types";

const InputBar = ({ onSend, disabled }) => {
  const [input, setInput] = useState("");
  const inputRef = useRef(null);

  const handleSend = async (message, input_type) => {
    if (input_type === INPUT_TYPES.TEXT) {
      if (message.trim() && !disabled) {
        await onSend(message.trim(), input_type);
        setInput("");
      }
    } else if (input_type === INPUT_TYPES.AUDIO) {
      await onSend(message, input_type);
      setInput("");
    } else {
      //TBD
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      const input_type = INPUT_TYPES.TEXT;
      handleSend(input, input_type);
    }
  };

  return (
    <div className="bg-white dark:bg-gray-800 shadow-lg dark:shadow-gray-900/50 rounded-full p-2 flex items-center space-x-2 mx-4 mb-4 transition-colors">
      <input
        ref={inputRef}
        type="text"
        value={input}
        onChange={(e) => setInput(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder="Type a message..."
        disabled={disabled}
        className="flex-grow bg-transparent px-4 py-2 outline-none text-gray-700 dark:text-gray-200 placeholder-gray-400 dark:placeholder-gray-500 disabled:opacity-50 transition-colors"
      />
      <motion.button
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
        onClick={handleSend}
        disabled={!input.trim() || disabled}
        className={`
          w-10 h-10 rounded-full flex items-center justify-center transition-colors duration-300
          ${
            input.trim() && !disabled
              ? "bg-blue-500 dark:bg-blue-600 text-white hover:bg-blue-600 dark:hover:bg-blue-700"
              : "bg-gray-200 dark:bg-gray-700 text-gray-400 dark:text-gray-500 cursor-not-allowed"
          }
        `}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M13 5l7 7-7 7M5 5l7 7-7 7"
          />
        </svg>
      </motion.button>
    </div>
  );
};

export default InputBar;


